export const getBaseURL = () => {
  return process.env.NEXT_PUBLIC_BASE_URL || "https://kvatronix.in.ua"
}
